export default __webpack_public_path__ + "static/media/quickspin-mono.f34371dd.svg";